import React from "react";
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';

import './styles.css';

const Solucao = () => {
  return (
    <>
      <Card className="text-center">
        <Card.Header><div className="opcoes">Dificuldade na Solução Adequada</div></Card.Header>
        <Card.Body>
          {/* <Card.Title>Crescimento exponencial</Card.Title> */}
          <Card.Text>
           <div className="opcoes">
            <strong>Configuração Ineficiente: </strong>
            Sem um estudo adequado dos equipamentos, os profissionais podem configurar mal os 
            roteadores e dispositivos de rede, resultando em baixo desempenho e falta de segurança. 
           </div>
           <div className="opcoes">
            <strong>Diagnosticar Problemas Complexos: </strong>
            Como profissionais, podemos enfrentar dificuldades ao diagnosticar problemas complexos de rede 
            devido a várias razões.
           </div>
           <hr />
           
           <div className="opcoes">
            <strong>Falta de Tempo: </strong>
            A agenda corrida pode limitar a profundidade da análise, impedindo a identificação detalhada 
            das causas subjacentes dos problemas de rede.
           </div>
           <div className="opcoes">
            <strong>Desconhecimento dos Dispositivos na Rede: </strong>
            Não conhecer todos os dispositivos conectados à rede pode dificultar a identificação de problemas como 
            conflitos de IP.
           </div>      
          </Card.Text>
          {/* <Button variant="primary">Go somewhere</Button> */}
        </Card.Body>
        {/* <Card.Footer className="text-muted">A automação residencial e a segurança são áreas em crescimento, exigindo conexões estáveis e seguras.</Card.Footer> */}
      </Card>
    </>
  )
}
export default Solucao;